import React from 'react';
import { useI18n } from '../../i18n/I18nContext';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';
import './Header.css';

export const Header: React.FC = () => {
  const { t } = useI18n();

  return (
    <header className='header'>
      <LanguageSwitcher />
      <p className='header-brand'>Brick My Name</p>
      <p className='header-tagline'>{t.headerTagline}</p>
    </header>
  );
};
